// eslint-no-undef
import React from 'react';
import Footer from './Footer';
import loginLogo from '../images/ugov_full_white.png';
import ForgotPasswordForm from './ForgotPasswordForm';
import '../App.css';

export default class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {email: undefined, username: undefined};
  }

  render() {
    return (
      <div className='signupPage'>
        <div className='titlediv'>
          <img className='signupLogo' src={loginLogo} alt='UGov' />
        </div>
        <ForgotPasswordForm />
        <hr className='footerHr' />
        <Footer />
      </div>
    );
  }
}
